import GenericLoading from '@cannect/components/GenericLoading'
import Button from 'new-components/Button'
import FileInput from 'new-components/FileInput'
import useAssociationDocuments from './hooks/useAssociationDocuments'
import * as Styles from './styles'

export default function AssociationDocuments() {
  const {
    loading,
    identityDocument,
    prescription,
    medicalReport,
    lawsuitTerm,
    savedFiles,
    changeFieldValue,
    handleSaveDocuments
  } = useAssociationDocuments()

  return (
    <Styles.DocumentsContainer>
      <GenericLoading loading={loading} />

      <h2>
        Inserir <strong>seus documentos:</strong>
      </h2>

      <Styles.DocumentsContent>
        <Styles.FileInputsWrapper>
          <FileInput
            label="Documento Pessoal (RG ou CNH)"
            description="O arquivo deve conter a frente e verso do documento"
            value={identityDocument?.name ?? savedFiles.identity_document?.originalName}
            onChange={(file) => changeFieldValue('identityDocument', file)}
            url={
              (identityDocument && 'url' in identityDocument ? (identityDocument as any).url : undefined) ??
              savedFiles.identity_document?.url
            }
          />
          <FileInput
            label="Termo de Ajuizamento"
            description="O arquivo deve conter o termo de ajuizamento"
            value={lawsuitTerm?.name ?? savedFiles.lawsuit_term?.originalName}
            onChange={(file) => changeFieldValue('lawsuitTerm', file)}
            url={
              (lawsuitTerm && 'url' in lawsuitTerm ? (lawsuitTerm as any).url : undefined) ??
              savedFiles.lawsuit_term?.url
            }
          />
        </Styles.FileInputsWrapper>

        <Styles.FileInputsWrapper>
          <FileInput
            label="Receita Médica"
            value={prescription?.name ?? savedFiles.prescription?.originalName}
            onChange={(file) => changeFieldValue('prescription', file)}
            url={
              (prescription && 'url' in prescription ? (prescription as any).url : undefined) ??
              savedFiles.prescription?.url
            }
          />
          <FileInput
            label="Laudo Médico"
            value={medicalReport?.name ?? savedFiles.medical_report?.originalName}
            onChange={(file) => changeFieldValue('medicalReport', file)}
            url={
              (medicalReport && 'url' in medicalReport ? (medicalReport as any).url : undefined) ??
              savedFiles.medical_report?.url
            }
          />
        </Styles.FileInputsWrapper>

        <Button
          onClick={handleSaveDocuments}
          disabled={!identityDocument && !prescription && !medicalReport && !lawsuitTerm}
          style={{ backgroundColor: '#02b0bb', color: '#FFFFFF' }}>
          SALVAR MEUS DOCUMENTOS
        </Button>
      </Styles.DocumentsContent>
    </Styles.DocumentsContainer>
  )
}
